import { useDesignTokens } from '@gamesite/game-core'
import { useImages } from 'hooks/useImages.js'
import { getConfig } from 'src/configs/index.js'

export function useMessageImages() {
  const { currentTheme } = useDesignTokens()
  const { getUrlWithModifier } = useImages()
  const darkTheme = getConfig().layoutTheme?.themes?.dark

  function getMessageProps(propsContent) {
    try {
      const props = propsContent?.props
      return typeof props === 'string' ? JSON.parse(props || '{}') || {} : props || {}
    } catch {
      return {}
    }
  }

  function getMessageImage(propsContent) {
    const props = getMessageProps(propsContent)
    const images = propsContent?.images || []
    const getImage = (id) => {
      const image = id ? images.find((image) => String(image.id) === String(id)) : null
      return image?.compressedImage?.webp || image?.compressed_image?.webp || null
    }

    return (
      (darkTheme && currentTheme.value === darkTheme && getImage(props.image_dark)) ||
      getImage(props.image) ||
      images[0]?.compressedImage?.webp ||
      images[0]?.compressed_image?.webp ||
      null
    )
  }

  function getSystemIconProps(message) {
    const props = getMessageProps(message?.propsContent)
    const darkIcon = darkTheme && currentTheme.value === darkTheme && props.icon_dark

    return {
      icon: darkIcon || props.icon || 'info',
      src: !darkIcon && message?.icon ? getUrlWithModifier(message.icon) : null,
    }
  }

  return { getMessageImage, getSystemIconProps }
}
